import {
  ACTION_AUTHKEY,
  ACTION_POST_CHANGEPASSWORD_REQ,
  ACTION_POST_LOGIN_REQ,
  ACTION_POST_LOGOUT_REQ,
  ACTION_SIDE_MENU,
  ACTION_POST_GENERATE_OTP_REQ,
  ACTION_POST_VALIDATE_OTP_REQ,
  ACTION_POST_RESET_PASSWORD_REQ,
} from "./SagaActionTypes";
  
  export const loginSagaAction = (payload) => ({
    type: ACTION_POST_LOGIN_REQ,
    payload,
  });

  export const logoutSagaAction = (payload) => ({
    type: ACTION_POST_LOGOUT_REQ,
    payload,
  });

  export const changePasswordSagaAction = (payload) => ({
    type: ACTION_POST_CHANGEPASSWORD_REQ,
    payload,
  });
  export const sideMenuAction = (payload) => ({
    type: ACTION_SIDE_MENU,
    payload,
  });
  export const clearSideMenuAction = (payload) => ({
    type: ACTION_SIDE_MENU,
    payload,
  });
  export const saveAuthKey = (payload) => ({
    type: ACTION_AUTHKEY,
    payload,
  });

  export const generateOTP = (payload) => ({
    type: ACTION_POST_GENERATE_OTP_REQ,
    payload,
  });
  export const validateOTP = (payload) => ({
    type: ACTION_POST_VALIDATE_OTP_REQ,
    payload,
  });
  export const resetPassword = (payload) => ({
    type: ACTION_POST_RESET_PASSWORD_REQ,
    payload,
  });